import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} payload - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onSearchPrioritiesSuccess = (
  payload = null,
  type = types.SUCCESS_SEARCH_PRIORITIES
) => {
  return {
    type,
    payload
  }
};

export const isSearchPrioritiesLoading = (
  payload = null,
  type = types.LOADING_SEARCH_PRIORITIES
) => {
  return {
    type,
    payload
  };
};
